import React, {useState, useEffect} from 'react';
import './CRM.scss';
import { useNavigate } from 'react-router-dom';
import { BarChart, Bar, XAxis, YAxis, Tooltip, PieChart, Pie, Cell,CartesianGrid, Legend, ResponsiveContainer } from 'recharts';
import { useMemo } from 'react';
import {fetchUserData} from '../../../../src/api/index';

function CRM() {
  const navigate = useNavigate();
  const [deals, setDeals] = useState([]);

    const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

useEffect(() => {
    const fetchDeals = async () => {
      const skip = 10;
      const limit = 50;
      const token = localStorage.getItem('token');
      if (!token) {
        console.error("No token found.");
        return;
      }

      try {
        const data = await fetchUserData(skip, limit);

        if (data?.details && Array.isArray(data.details)) {
          setDeals(data?.details);
          console.log(deals);
        } else {
          alert(data.message || 'Failed to load deals');
        }
      } catch (error) {
        console.error('Error fetching deals:', error);
      }
    };
    fetchDeals();
  }, []);

const getLeadStatusSummary = () => {
  const summary = {};

  deals.forEach(deal => {
    const status = deal.leadstatus || 'Other';
    const value = parseFloat(deal.dealvalue) || 0;

    if (!summary[status]) {
      summary[status] = { count: 0, totalValue: 0 };
    }

    summary[status].count += 1;
    summary[status].totalValue += value;
  });

  return Object.entries(summary).map(([status, data]) => ({
    name: status,
    count: data.count,
    totalValue: data.totalValue
  }));
};



const winLossData = useMemo(() => {
  const statusCounts = {
    Won: 0,
    Lost: 0,
  };

  deals.forEach(deal => {
    const status = deal.leadstatus;
    const value = parseFloat(deal.dealvalue) || 0;

    if (status === 'Won') {
      statusCounts.Won += value;
    } else if (status === 'Lost') {
      statusCounts.Lost += value;
    }
  });

  return Object.entries(statusCounts).map(([name, value]) => ({ name, value }));
}, [deals]);


console.log("Win/Loss Data: ", winLossData);


const { wonPercentage, lostPercentage } = useMemo(() => {
  let wonValue = 0;
  let lostValue = 0;

  deals.forEach(deal => {
    const value = parseFloat(deal.dealvalue) || 0;
    if (deal.leadstatus === 'Won') {
      wonValue += value;
    } else if (deal.leadstatus === 'Lost') {
      lostValue += value;
    }
  });

  const total = wonValue + lostValue;

  const wonPercentage = total > 0 ? ((wonValue / total) * 100).toFixed(2) : 0;
  const lostPercentage = total > 0 ? ((lostValue / total) * 100).toFixed(2) : 0;

  return { wonPercentage, lostPercentage };
}, [deals]);




const summary = getLeadStatusSummary();


const leadStatusData = useMemo(() => {
  const summary = {};

  deals.forEach(deal => {
    const status = deal.leadstatus || 'Other';
    const value = parseFloat(deal.dealvalue) || 0;

    if (!summary[status]) {
      summary[status] = { count: 0, totalValue: 0 };
    }

    summary[status].count += 1;
    summary[status].totalValue += value;
  });

  return Object.entries(summary).map(([status, data]) => ({
    name: status,
    count: data.count,
    totalValue: data.totalValue
  }));
}, [deals]);



 const dealStageData = useMemo(() => {
  const stageMap = {};

  deals.forEach(deal => {
    const stage = deal.leadstatus || 'Other';
    const value = parseFloat(deal.dealvalue) || 0;

    if (!stageMap[stage]) {
      stageMap[stage] = 0;
    }

    stageMap[stage] += value;
  });

  return Object.entries(stageMap).map(([name, value]) => ({ name, value }));
}, [deals]);

  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
  const COLORS1 =  ['#3F51B5', '#009688', '#00BCD4', '#9C27B0'];
    return (
      <div className="crm-container">
        <div className="crm-nav">
          <div className='crm-menu' onClick={() => navigate("/crm")}>Dashboard</div>
          <div className='crm-menu' onClick={() => navigate("/deals")}>Deals</div>
          <div className='crm-menu' onClick={() => navigate("/activities")}>Activities</div>
      </div>

   <div className="crm-dashboard">
  <div className="top-row">
    <div className="left-column">
      <div className="metric-boxes">
      <div className="metric-box">
        <h4>Revenue Won</h4>
        <p className="win" >{wonPercentage}%</p>
      </div>
      <div className="metric-box">
        <h4>Revenue Lost</h4>
        <p className="lost">{lostPercentage}%</p>
      </div>
      </div>
    <div className="chart-box">
  <h4>Deal Win/Loss Count</h4>
<ResponsiveContainer width="100%" height={300}>
  <BarChart data={winLossData}>
    <CartesianGrid strokeDasharray="3 3" />
    <XAxis dataKey="name" />
    <YAxis />
    <Tooltip />
    <Legend />
    <Bar dataKey="value">
      {winLossData.map((entry, index) => (
        <Cell key={`cell-${index}`} fill={index === 0 ? '#4CAF50' : '#F44336'} /> 
      ))}
    </Bar>
  </BarChart>
</ResponsiveContainer>
</div>

    </div>
 
    <div className="chart-box">
      <h4>Open Deal Value by Stage</h4>
     

      <PieChart width={300} height={300} marginTop={40}>
  <Pie
    data={dealStageData}
    cx="50%"
    cy="50%"
    labelLine={false}
    outerRadius={75}
    dataKey="value"
    label={({ name, value }) => `${name}: $${(value / 1000).toFixed(1)}K`}
  >
    {dealStageData.map((entry, index) => (
      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
    ))}
  </Pie>
  <Tooltip />
</PieChart>
    </div>

         <div className="chart-box">
            <h4 style={{ textAlign: 'center' }}>Quarterly Financials (Stacked Bar Chart)</h4>
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={dealStageData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="value" >
                  {dealStageData.map((entry, index) => (
                 <Cell key={`cell-${index}`} fill={COLORS1[index % COLORS.length]} />
                 ))}
               </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
     <div className="chart-box">
  <h4 style={{ textAlign: 'center' }}>Lead Status Summary</h4>
    <ResponsiveContainer width="100%" height={300}>
  <BarChart width={500} height={300} data={leadStatusData}>
    <CartesianGrid strokeDasharray="3 3" />
    <XAxis dataKey="name" />
    <YAxis />
    <Tooltip />
    <Legend />
    <Bar dataKey="totalValue" fill="#8884d8" name="Total Deal Value" />
    <Bar dataKey="count" fill="#82ca9d" name="Number of Deals" />
  </BarChart>
  </ResponsiveContainer>
</div>

  </div>
</div>

    </div>
  );
}

export default CRM;